import { IGameState } from 'State/Game/IGameState';
import { IAPReward } from 'Utility/RewardHelper';
import { trackPurchase, trackPurchaseStatus } from 'Utility/Tracking/TrackingHelpers/Transaction';
import { PurchaseStatus } from 'Utility/Tracking/TrackingHelpers/PurchaseStatus';
import Game from 'Game';
import { PurchaseFailReason } from 'Utility/SDK/Drivers/PurchaseFailReason';
import { clearTrackingData } from 'Utility/Tracking/Track';
import { TransactionDataHandler } from 'Utility/Tracking/Handler/Transaction';
import { GameActions } from 'State/Game/GameActions';
import { ResponseStatus, ResponseType } from 'State/Game/ContextType';

export async function purchaseProduct(
    state: IGameState,
    data: {
        product: IAPReward;
    }
) {
    const productId = data.product.id;
    trackPurchaseStatus(productId, PurchaseStatus.START);

    try {
        await Game.sdk.purchaseProduct(productId);
    } catch (e) {
        const failReason: PurchaseFailReason = Object.values(PurchaseFailReason).includes(e.code)
            ? e.code
            : PurchaseFailReason.OTHER;

        trackPurchaseStatus(productId, PurchaseStatus.FAIL, failReason);
        clearTrackingData(TransactionDataHandler);
        GameActions.restoreContext(ResponseStatus.FAIL, ResponseType.PURCHASE_PRODUCT, {
            errorMsg: Game.locale.getText('PurchaseFailed'),
        });
        return;
    }

    // purchase was successful
    GameActions.restoreContext(ResponseStatus.SUCCESS, ResponseType.PURCHASE_PRODUCT, {
        product: data.product,
    });
    trackPurchaseStatus(productId, PurchaseStatus.SUCCESS);
    trackPurchase(state, productId, data.product.rewards);
}
